import React from "react";
import { Span } from "../../../../../Span";
import { Flex } from "../../../../../Flex";
import {
  ContactDetails,
  ContactDetailsValues,
} from "../../../../../../types/ContactDetailsValues";
import {
  hasAnyRoleAssigned,
  mapAssignedRolesAsHeader,
} from "../../../../../ContactDetailsForm/ContactDetailsAndRole/_/utils/AssignedRolesUtils";
import { ReviewFormContactDetails } from "../../../../../ReviewFormContactDetails";
import { Box } from "../../../../../Box";

interface Props {
  id: string;
  contactDetails: ContactDetails[];
}
export const ReviewFormDisconnectionContactDetails: React.FC<Props> = ({
  id,
  contactDetails,
}) => {
  const mapperContactDetailsValues = (contactDetail: ContactDetails) => {
    const isQuotePayer = contactDetail.roles.quotePayer;
    const billingAddress = isQuotePayer
      ? contactDetail.manuallyEnteredBillingAddress
        ? `${contactDetail.manualBillingAddress.addressString} ${contactDetail.manualBillingAddress.suburb} ${contactDetail.manualBillingAddress.city} ${contactDetail.manualBillingAddress.postcode}`
        : contactDetail.billingAddressDisplay
      : "";
    const quotePreferences = isQuotePayer
      ? contactDetail.quoteContactPreferences
      : undefined;
    const contactDetailsValues: ContactDetailsValues = {
      firstName: contactDetail.firstName,
      lastName: contactDetail.lastName,
      email: contactDetail.email,
      mobile: contactDetail.mobile,
      alternatePhone: contactDetail.alternatePhone,
      businessName: contactDetail.businessName,
      businessNumber: contactDetail.businessNumber,
      billingAddress: billingAddress,
      workContactPreferences: contactDetail.workContactPreferences,
      quoteContactPreferences: quotePreferences,
    };
    return contactDetailsValues;
  };

  return (
    <Flex id={id} flexDirection="column">
      {contactDetails
        .filter((contactDetail) => hasAnyRoleAssigned(contactDetail.roles))
        .map((contactDetail: ContactDetails, index: number) => (
          <Box id={`${id}[${index}]`} key={`${id}[${index}]`}>
            <Span lineHeight={2} fontWeight="bold" mb={3}>
              {mapAssignedRolesAsHeader(
                contactDetail.role,
                contactDetail.roles,
              )}
            </Span>
            <ReviewFormContactDetails
              contactDetails={mapperContactDetailsValues(contactDetail)}
            />
          </Box>
        ))}
    </Flex>
  );
};
